import { FC } from 'react';
import Link from 'next/link';
import RoundedImageCard from '@/components/RoundedImageCard';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { useSettingsContext } from '@/contexts/SettingsContext';
import { getLocalizedLink } from '@/utils/getLocalizedLink';

interface InsightCardProps {
    id: string;
    description: string;
    image?: string;
    imageAlt?: string;
    category: string;
    uri: string;
    onCategoryClick: (cat: string) => void;
}

const InsightCard: FC<InsightCardProps> = ({
    id,
    image,
    imageAlt,
    category,
    description,
    uri,
    onCategoryClick,
}) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });
    const { lang } = useSettingsContext();
    const href = getLocalizedLink(`/insights/${uri}`, lang);

    return (
        <RoundedImageCard
            image={image}
            alt={imageAlt ?? description}
            inspectorProps={inspectorProps({
                fieldId: 'heroimage',
            })}
        >
            <div className="tw-flex tw-justify-between tw-flex-col tw-items-start tw-px-[20px] tw-pt-[20px] tw-pb-[40px]">
                <div className="">
                    <Link href={href}>
                        <h2
                            className="tw-text-[#003865] tw-mb-[25px] tw-font-gotham-medium  tw-pb-[5px] tw-text-[16px] tw-tracking-wide tw-leading-[26px] hover:tw-underline tw-transition-all tw-duration-900"
                            {...inspectorProps({
                                fieldId: 'title',
                            })}
                        >
                            {description}
                        </h2>
                    </Link>
                </div>
                <div className="tw-flex tw-justify-start tw-items-center">
                    <h3 className="tw-text-[#ce0058] tw-mr-2 tw-absolute tw-bottom-[20px] tw-lefft-[20px] tw-font-medium tw-text-[14px] tw-tracking-wide tw-leading-[26px] hover:tw-underline tw-transition-all tw-duration-900 tw-cursor-pointer ">
                        <span
                            onClick={() => onCategoryClick(category)}
                            {...inspectorProps({
                                fieldId: 'division',
                            })}
                        >
                            {category}
                        </span>
                    </h3>
                </div>
            </div>
        </RoundedImageCard>
    );
};

export default InsightCard;
